<template>
  <section class="barocare-conci-home">
  
    <div class="img-area">
      <img src="../../assets/pc_barocare_conci/bg-home.png" alt="">
    </div>      
    <div class="title-area" >
      <h2 class="title" v-intersect>
        <span class="sr-only">솔닥컨시어지</span><img src="../../assets/pc_barocare_conci/img-logo-white.png" alt=""></h2>
      <p class="sub-text" v-intersect>500만 당뇨인을 위한 디지털 맞춤 솔루션</p>
      <div class="btn-area" v-intersect>
        <!-- <a href="http://pf.kakao.com/_xoDxeJG/chat" target="_blank" title="새창" class="btn-go">서비스 문의하기</a> -->
        <a href="https://solcon.channel.io/home" target="_blank" title="새창" class="cta_007 btn-go type2"><i class="ico-chat"></i>간편 채팅 상담</a>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'BarocareConciHome',
 
  directives: {
    intersect: {
      // 요소가 DOM에 삽입될 때 호출됩니다.
      inserted(el) {
        const options = {
          root: null, // 뷰포트를 기본값으로 설정
          rootMargin: '0px', // 뷰포트의 마진은 0
          threshold: 0.1 // 10%가 보일 때 콜백이 실행
        };
        const callback = (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              el.classList.add('visible');
            } else {
              el.classList.remove('visible');
            }
          });
        };
        const observer = new IntersectionObserver(callback, options);
        observer.observe(el); // 해당 요소를 관찰 시작
      }
    }
  },
};
</script>


<style scoped>
   

</style>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_conci/BarocareConciHome.vue